"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const playlists_1 = require("../../api/playlists");
const TrackListComponent_1 = __importDefault(require("../../components/trackList/TrackListComponent"));
const notInitialized_1 = require("../../utils/notInitialized");
const TrackDropdownService_1 = __importDefault(require("./TrackDropdownService"));
const TrackPresenter_1 = __importDefault(require("./TrackPresenter"));
const AddTrackModalService_1 = __importDefault(require("./AddTrackModalService"));
const TracksType_1 = require("../../types/TracksType");
class TrackListPresenter {
    constructor(parentElement, tracksModel, playlistsModel, playerModel, dropdownService, modalService) {
        this.parentElement = parentElement;
        this.tracksModel = tracksModel;
        this.playlistsModel = playlistsModel;
        this.playerModel = playerModel;
        this.createLikeCallback = () => notInitialized_1.notInitialized;
        this.trackListComponent = new TrackListComponent_1.default(tracksModel);
        this.trackDropdownService = new TrackDropdownService_1.default(dropdownService);
        this.addTrackModalService = new AddTrackModalService_1.default(modalService, playlistsModel, playerModel);
    }
    createAddModalCallback(id) {
        return () => {
            this.addTrackModalService.open(id);
        };
    }
    createDropdownCallback(id, deleteCallback, openModalCallback) {
        return (event) => {
            event.stopPropagation();
            const isPlaylist = this.tracksModel.playlistId !== null;
            this.trackDropdownService.openDropdown(id, deleteCallback, openModalCallback, isPlaylist);
        };
    }
    createDeleteCallback(trackId) {
        return async () => {
            const playlistId = this.tracksModel.playlistId;
            if (!playlistId) {
                throw new Error('playlistId is null');
            }
            await (0, playlists_1.removeFromPlaylist)(playlistId, trackId);
            this.playlistsModel.removeTrack(playlistId, trackId);
            this.tracksModel.setAll(this.playlistsModel.get(playlistId).songs);
            this.playlistsModel.onChange();
            if ((this.playerModel.tracksType === TracksType_1.TracksType.Playlist &&
                this.playerModel.playlistId === this.tracksModel.playlistId) ||
                this.playerModel.tracksType === this.tracksModel.tracksType) {
                this.playerModel.originalTracks = this.tracksModel.all();
                this.playerModel.track.index--;
                this.playerModel.onTrackListChange();
            }
        };
    }
    render() {
        this.trackListComponent.removeElement();
        const trackListElement = this.trackListComponent.getElement();
        this.parentElement.append(trackListElement);
        const trackListUl = document.getElementById('tracks-list');
        if (trackListUl instanceof HTMLElement) {
            for (const trackData of this.tracksModel.allWithSearch()) {
                new TrackPresenter_1.default(trackListUl, trackData, this.playerModel, this.tracksModel, this.createLikeCallback(trackData), this.createDropdownCallback(trackData.id, this.createDeleteCallback(trackData.id), this.createAddModalCallback(trackData.id)));
            }
        }
    }
}
exports.default = TrackListPresenter;
